import Axios from '../../../../common/util/Axios';
import store from '../../../../store';

export const getStocksByProductForTransfer = async (branchId, productId, companyId) => {
  const res = await Axios.get('/api/dashboard/stocks/search-stocks', {
    params: {
      companyId,
      branchId,
      keyword: '',
      page: 0,
      rowsPerPage: 200,
      productId,
      supplierId: '',
      remainingQuantity: 'NON_ZERO',
    },
  });

  const rows = res.data?.data?.data;
  const data = Array.isArray(rows) ? rows : [];

  // Keep transfer UI compatibility with the previous stock shape.
  return data.map((item) => ({
    id: item.id,
    qty: Number(item.qty) || 0,
    created_at: item.createdDate ? new Date(item.createdDate).toISOString() : null,
    unit: item.unit,
    selling_price: Number(item.unitPrice) || 0,
    unit_cost: Number(item.unitCost) || 0,
  }));
};

export const searchStockTransfers = async (params = {}) => {
  const companyId = params.companyId ?? store.getState().authState.companyId;
  const res = await Axios.get('/api/dashboard/stock-transfers/search', {
    params: {
      companyId,
      start_date: params.start_date || '',
      end_date: params.end_date || '',
      page: params.page || 1,
      item_count: params.item_count || 10,
      fromBranchId: params.fromBranchId || '',
      toBranchId: params.toBranchId || '',
    },
  });
  return res.data;
};

export const createStockTransfer = async (payload) => {
  const authState = store.getState().authState || {};
  const requestBody = {
    companyId: payload.companyId ?? authState.companyId,
    fromBranchId: payload.fromBranchId,
    toBranchId: payload.toBranchId,
    items: Array.isArray(payload.items) ? payload.items : [],
  };

  const res = await Axios.post('/api/dashboard/stock-transfers/create', requestBody);
  return res.data;
};
